import {
  Dialog,
  DialogTitle,
  IconButton,
  Modal,
  ModalTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import UnAuthorisedUser from "../../components/UnAuthorisedUser";
import { isValidUser } from "../../components/validTPUser";
import { CONFIRM_SUBMITTED_TRANSACTION } from "../../utilities/constants";
import ToastUtility from "../Utility/toast-utility";
import { useDispatch } from "react-redux";
import { RLTD_ACC_AVL } from "../../action.js";
import { Close } from "@mui/icons-material";

function TpMain(props) {
  const validUser = isValidUser(props.businessActivities);
  const [toastDisplay, setToastDisplay] = useState("none");
  const [showInfoToast, setShowInfoToast] = useState("inline");
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.relatedAccount.authorized) {
      dispatch({ type: RLTD_ACC_AVL });
    }
    if (sessionStorage.getItem("showInfoToast") === null)
      sessionStorage.setItem("showInfoToast", "inline");
    if (props.createTransactionResponse) {
      props.clearCreateTransaction();
      setToastDisplay("inline");
      setTimeout(() => {
        setToastDisplay("none");
      }, 5000);
    }
  }, []);

  const handleCloseReviewModal = () => {
    setShowInfoToast("none");
    sessionStorage.setItem("showInfoToast", "none");
  };

  const checkSimulatedBusinessActivities = (activities) => {
    return (
      activities !== null &&
      activities !== undefined &&
      Object.keys(activities).length
    );
  };

  return (
    <>
      {validUser && props.relatedAccount.authorized ? (
        sessionStorage.getItem("showInfoToast") !== null &&
        sessionStorage.getItem("showInfoToast") !== undefined &&
        sessionStorage.getItem("showInfoToast") !== "none" ? (
          props.isSimulateMode ? (
            checkSimulatedBusinessActivities(
              props.simulatedBusinessActivities
            ) ? (
              Object.entries(props.simulatedBusinessActivities).find(
                ([key, value]) =>
                  key === CONFIRM_SUBMITTED_TRANSACTION.activityId
              ) ? (
                <Dialog
                  open={showInfoToast && props.txnsForReviewCount}
                  onClose={handleCloseReviewModal}
                  aria-labelledby="alert-Modal-title"
                  aria-describedby="alert-Modal-description"
                >
                  <DialogTitle
                    id="alert-Modal-title"
                    style={{ fontWeight: "normal" }}
                  >
                    {`${props.texts.TXN_WAIT_F0R_REVIEW_MSG_1} ${props.txnsForReviewCount} ${props.texts.TXN_WAIT_F0R_REVIEW_MSG_2}`}
                    &nbsp;
                    <IconButton
                      aria-label={"close"}
                      onClick={handleCloseReviewModal}
                      size={"large"}
                    >
                      <Close />
                    </IconButton>
                  </DialogTitle>
                </Dialog>
              ) : (
                <div />
              )
            ) : (
              <div />
            )
          ) : checkSimulatedBusinessActivities(props.businessActivities) ? (
            Object.entries(props.businessActivities).find(
              ([key, value]) => key === CONFIRM_SUBMITTED_TRANSACTION.activityId
            ) ? (
              <Dialog
                open={showInfoToast && props.txnsForReviewCount}
                onClose={handleCloseReviewModal}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
              >
                <DialogTitle
                  id="alert-Modal-title"
                  style={{ fontWeight: "normal" }}
                >
                  {`${props.texts.TXN_WAIT_F0R_REVIEW_MSG_1} ${props.txnsForReviewCount} ${props.texts.TXN_WAIT_F0R_REVIEW_MSG_2}`}
                  &nbsp;
                  <IconButton
                    aria-label={"close"}
                    onClick={handleCloseReviewModal}
                    size={"large"}
                  >
                    <Close />
                  </IconButton>
                </DialogTitle>
              </Dialog>
            ) : (
              <div />
            )
          ) : (
            <div />
          )
        ) : (
          <div />
        )
      ) : (
        <UnAuthorisedUser
          message={
            !props.relatedAccount.authorized
              ? "User details not available at a moment! Please try after some time."
              : "You are not authorized to access the site. Please contact your Dealer Profile Administrator."
          }
        />
      )}

      {props.createTransactionResponse && (
        <ToastUtility
          toastDisplay={toastDisplay}
          toastVariant="success"
          toastMessage={
            props.createTransactionResponse.txnStatus !== "DELETED"
              ? props.texts.TXN_SUCCESS_MSG
              : props.texts.TRANS_DEL_SUCCESS_MSG
          }
        />
      )}
    </>
  );
}

export default TpMain;
